import { Component, ElementRef, OnInit } from '@angular/core';
import { Broadcaster } from '../../service/Broadcaster';
import { Observable } from 'rxjs/Rx';

@Component({
    selector: 'confirm-budget',
    templateUrl: './confirm-budget.component.html',
    styleUrls: ['./confirm-budget.component.css']
})
export class ConfirmBudgetComponent implements OnInit{
    text = '';
    type = '';

    constructor(private broadcaster: Broadcaster, private elRef: ElementRef) { }

    ngOnInit() {
     
        this.broadcaster.on<any>('confirmBudget').subscribe(data => {
            this.defaultData(data);
            this.text = data.text;
        });
        this.broadcaster.on<any>('remove').subscribe(data=>{
            this.text = data.text;
            this.type = data.type;
            this.defaultData(data)
        })
    }
    defaultData(d){
        let elm = <HTMLElement>document.querySelector(".confirm");
        elm.style.display = "block";
        document.querySelector(".budgetContainer").classList.add("blur");
        document.querySelector(".wrapper").classList.add("blur");
        
    }
    Confirm(){
        if(this.type === 'remove'){
            this.broadcaster.broadcast("confirmRemove", {
                data: "remove"
            })
        }else{
            this.broadcaster.broadcast("confirmBudgetBroadcast", {
                data: "Delete"
            });
        }
        let elm = <HTMLElement>document.querySelector(".confirm");
        elm.style.display = null;
        document.querySelector(".budgetContainer").classList.remove("blur");
        document.querySelector(".wrapper").classList.remove("blur");
        this.text = '';
        this.type = '';
    }
    Cancel(){
      
        if(this.type === 'remove'){
            this.broadcaster.broadcast("noRemove", {
                data: "No remove"
            })
        }else{
            this.broadcaster.broadcast("confirmBudgetBroadcast", {
                data: "Cancel"
            });
        }
        let elm = <HTMLElement>document.querySelector(".confirm");
        elm.style.display = "none";
        document.querySelector(".budgetContainer").classList.remove("blur");
        document.querySelector(".wrapper").classList.remove("blur");
        this.text = '';
        this.type = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/components/budget/confirm-budget/confirm-budget.component.ts